export default __webpack_public_path__ + "static/media/raki_perspective.d4dc987d.jpg";